import Trans from 'next-translate/Trans'
import { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { GButton, GCheckBox, GInput } from 'tennders-common/form/components'
import useAssignTo from 'tennders-transactions/hooks/useAssignTo'
import GModal from 'tennders-market/common/components/element/GModal'
import { CheckboxProps } from 'tennders-common/form/components/checkbox'
import { ModalProps } from 'tennders-common/types/ModalProps'
import useInitials from 'tennders-common/hooks/useInitials'
import { UserType } from 'tennders-auth/types/UserType'

import dynamic from 'next/dynamic'

const EllipsisToolTip = dynamic(() => import('ellipsis-tooltip-react-chan'), { ssr: false })

type SingleLineProps = {
  user ?: UserType,
  onSet ?: CheckboxProps['onSet'],
  checked ?: CheckboxProps['value']
}

const SingleLine = ({ user, onSet, checked }: SingleLineProps) => (
  <>
    <div className="hr mt-10 mb-10" />
    <GCheckBox
      onSet={onSet}
      value={checked}
      label={(
        <div className="d-flex">
          {user.name}{' '}
          <span className="table-text d-block conform-email">
            <EllipsisToolTip options={{ className: 'custom-color-tooltip' }}>
              {' - cc'} {user.email}
            </EllipsisToolTip>
          </span>
        </div>
      )}
      className="form-checkbox"
    />
  </>
)

const MAssignTo = (props: ModalProps) => {
  const { assignTo, submitAssignTo, setAssignTo, fetchAssignedUsers, assignedUsers, canBeAssignedMultiple } = useAssignTo()
  const { internals: users } = useInitials()
  const { t } = useTranslation()
  const [filter, setFilter] = useState('')
  const [filtereds, setfiltereds] = useState([])
  const [ids, setids] = useState([])

  useEffect(() => {
    if (users) {
      setfiltereds(users)
    }
  }, [users])

  useEffect(() => {
    if (assignedUsers.length > 0 && users.length > 0) {
      const assigneds = assignedUsers.map((user) => user.id)
      setids(assigneds)
      const fUsers = [...filtereds]
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fUsers.sort((a, b) => assigneds.includes(b.id) - assigneds.includes(a.id))
      setfiltereds(fUsers)
    }
  }, [assignedUsers, users])

  const [submitting, setsubmitting] = useState(false)

  const submit = async () => {
    setsubmitting(true)
    await submitAssignTo(assignTo, { ids })
    setsubmitting(false)
  }

  const toggleIds = (id, selected) => {
    let copy = [...ids]
    if (canBeAssignedMultiple) {
      if (selected && !ids.includes(id)) {
        copy.push(id)
      } else {
        copy.splice(copy.indexOf(id), 1)
      }
    } else {
      copy = selected ? [id] : []
    }

    setids(copy)
  }

  const filterUsers = (keyword) => {
    setFilter(keyword)

    if (keyword === '') {
      return
    }

    const newUsers = [...users].filter((user) => user.name.includes(keyword) || user.email.includes(keyword))
    setfiltereds(newUsers)
  }

  useEffect(() => {
    setids([])
    if (assignTo) {
      fetchAssignedUsers(assignTo)
    }
  }, [assignTo])

  return (
    <GModal
      isOpen={!!assignTo}
      size={600}
      close={async () => {
        setFilter('')
        const newUsers = [...users]
        setfiltereds(newUsers)
        setAssignTo(false)
      }}
      {...props}
    >
      <div className="tennders-modal-body w-100">
        <h3 className="bold mb-20">{t('modal:assignTransactionTo')}</h3>
        <GInput
          onlyInput
          onSet={(val) => filterUsers(val)}
          type="text"
          name="search"
          form={{ search: filter }}
          className="form-input small mb-10 w-100"
          placeholder={t('modal:typeToFilter')}
        />
        <div style={{ overflow: 'scroll', height: 250 }}>
          {' '}
          {
            filtereds ? filtereds.map((user, index) => (
              <SingleLine
                key={index}
                checked={ids.includes(user.id)}
                user={user}
                onSet={(selected) => toggleIds(user.id, selected)}
              />
            )) : undefined
          }
        </div>
        <GButton
          disabled={ids.length === 0}
          onClick={submit}
          submitting={submitting}
          className="btn standard-btn btn-w-icon bold mt-20 mb-2 w-100 flex-center"
        >
          <Trans i18nKey="modals:save" />
        </GButton>
      </div>

    </GModal>
  )
}

export default MAssignTo
